<template>
  <el-container id="main-index" direction="vertical" v-loading="mainLoading">
    <el-main class="mainIndex-main">
      <!-- 首页通知白条 -->
      <!-- <div class="notice qm-card">
        <img class="icon" src="./noteice.png" alt="noteice" />
        <div class="text">
          <a
            href="https://qingmang.zendesk.com/hc/zh-cn/articles/360038583531"
            target="_blank"
            >通知：「推送」功能将于 2020 年 1 月 10
            日对新用户下线，老用户暂时不受影响。</a
          >
        </div>
        <a class="join" href="#">立即参与</a>
      </div> -->
      <section v-if="showEmptyGroup" class="empty-group">
        <div class="empty-tip">
          开始创建你的第一个小程序吧。
        </div>
        <qm-button
          icon="lib-plus"
          text="新建小程序"
          @click="showCreatePublicationSection"
        />
      </section>
      <!-- 分类 type -->
      <template v-else>
        <section
          v-for="item in publicationTypes"
          v-show="item.list.length"
          :key="item.type"
          class="publication-group"
        >
          <header class="publication-group-header">
            <img :src="item.icon" alt="图标" />
            <span>{{ item.name }} </span>
            <span v-if="item.type === 'podcast'" class="test">内测版</span>
          </header>
          <main class="publication-group-body">
            <router-link
              v-for="publication in item.list"
              :key="publication.id"
              class="publication-group-body-item"
              :to="`/${publication.pubType}/${publication.id}/`"
              target="_blank"
            >
              <PublicationCard :publication="publication" />
            </router-link>
          </main>
        </section>
      </template>

      <section v-if="showcases" class="showcases-group">
        <header class="showcases-title">
          精彩案例
        </header>
        <main class="showcases-container">
          <publication-show-case
            v-for="item in showcases"
            :key="item.id"
            :card-info="item"
            @createPublication="handleClickCreatePublication(item)"
          />
        </main>
        <footer class="showcase-footer">
          <a href="http://showcase.qingmang.mobi" target="_blank">
            <qm-button text="查看更多案例" />
          </a>
        </footer>
      </section>
    </el-main>
    <MainPact />
  </el-container>
</template>

<script>
/* eslint-disable */

import {mapGetters, mapActions} from 'vuex'
import * as qm from 'src/utils/utils'
import * as api from 'src/api/index'
import * as formatter from 'src/utils/formatter'
import MainPact from 'src/views/main/MainPact.vue'
import PublicationCard from 'src/components/publication/PublicationCard.vue'
import PublicationShowCase from 'src/components/preview/PublicationShowCase.vue'
/* eslint-enable */
export default {
  name: 'MainIndex',
  components: {
    MainPact,
    PublicationCard,
    PublicationShowCase,
  },
  data() {
    return {
      createForm: {},
      createFormShow: false,
      list: [],
      publicationTypes: [
        {
          icon: '/static/icon/publication-icon/publication-type-brand.svg',
          name: '品牌小程序',
          desc:
            '在微信里搭建一个独特的品牌官网。支持多种排版样式、丰富的页面组件、自定义品牌视觉、客服等功能。',
          type: 'brand',
          list: [],
        },
        {
          icon: '/static/icon/publication-icon/publication-type-podcast.svg',
          name: '播客小程序',
          desc:
            '在微信里搭建一个独特的品牌官网。支持多种排版样式、丰富的页面组件、自定义品牌视觉、客服等功能。',
          type: 'podcast',
          list: [],
        },
        {
          icon: '/static/icon/publication-icon/publication-type-content.svg',
          name: '杂志小程序',
          desc:
            '把你的内容装订成一本自动更新的杂志。支持多级栏目分类、自动同步内容、打开公众号图文、自定义品牌视觉等功能。',
          type: 'content',
          list: [],
        },
        {
          icon: '/static/icon/publication-icon/publication-type-quiz.svg',
          name: '答题小程序',
          desc:
            '闯关对战等多种答题机制，微信好友和全网排行榜，充分满足你的活动需求。',
          type: 'quiz',
          list: [],
        },
        {
          icon: '/static/icon/publication-icon/publication-type-daily.svg',
          name: '日签小程序',
          desc:
            '在简单的滑动中享受内容之美，用日签海报为用户创造一个独特的每日打开和分享场景。',
          type: 'daily',
          list: [],
        },
        // {
        //   icon: '/static/icon/publication-icon/publication-type-group.svg',
        //   name: '社群小程序',
        //   desc:
        //     '灵活而全面的运营工具，丰富的功能有助于维护读者、客户或粉丝群体。',
        //   type: 'group',
        //   list: [],
        // },
      ],
      showcases: undefined,
      mainLoading: true,
    }
  },
  computed: {
    showEmptyGroup() {
      return this.publicationTypes.every(item => item.length === 0)
    },
    remainList() {
      return this.list.filter(publication => publication.status !== 'deleted')
    },
    ...mapGetters({
      accountInfo: 'accountInfo',
      publicationInfo: 'publicationInfo',
      libInfo: 'libInfo',
      createStep: 'createStep',
      magazineConfig: 'magazineConfig',
    }),
  },
  created() {
    qm.GAPageView('/')
    this.init()
  },
  methods: {
    async init() {
      this.list = []
      this.createForm = {}
      this.createFormShow = false
      await this.getPublicationList()
      this.mainLoading = false
      this.getShowcases()
    },
    GA: qm.GA,
    async getPublicationList() {
      try {
        const res = await api.Ajax({url: '/v2/publication.getAll'})
        if (res.ok) {
          res.publications.map((event, i) => {
            const publication = formatter.publicationFormatter(event)
            // 临时征用为品牌小程序
            if (qm.get(publication, 'config.enableUserForm') === true) {
              publication.pubType = 'brand'
            }
            this.publicationTypes.forEach(item => {
              if (
                publication.status !== 'deleted' &&
                item.type === publication.pubType
              ) {
                item.list.push(publication)
              }
            })
          })
          if (!this._checkHavePublication()) {
            this.showCreatePublicationSection()
          }
        }
      } catch (e) {
        qm.log('e', e)
        this.$message.error(e.message)
      }
    },
    async getShowcases() {
      const res = await api.getShowCases()
      if (res.ok) {
        this.showcases = res.mainShowCases
      }
    },
    _checkHavePublication() {
      return this.publicationTypes.some(type => type.list.length)
    },
    handleClickCreatePublication(item) {
      window.open(`/create?type=${item.type}`)
    },
    // 对外暴露的一个展示创建 publication 分类的方法
    showCreatePublicationSection() {
      this.$router.push('/create')
      qm.GA('ui', 'opened_publication_type_panel', '')
    },
    ...mapActions({
      setAccountInfo: 'setAccountInfo',
    }),
  },
}
</script>

<style lang="scss">
@import '~static/css/ref';

#main-index {
  flex: 1;
  position: relative;

  .el-dialog {
    padding: 0 40px;
  }

  .el-dialog__header {
    font-weight: bold;
    padding: 22px 0 20px;
  }

  .el-dialog__headerbtn {
    right: 45px;
    font-size: 20px;
  }

  .el-dialog__body {
    padding: 24px 0;
  }

  .mainIndex-main {
    overflow-y: auto;

    .notice {
      margin: 35px auto 42px;
      padding: 0 24px;
      width: 1140px;
      display: flex;
      align-items: center;
      height: 72px;
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 16px;
      }
      .text {
        flex: 1;
      }
      .join {
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }
    }

    .empty-group {
      width: 1140px;
      margin: 0 auto;
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-bottom: 2px dashed #d8d8d8;

      .empty-tip {
        color: #000000;
        font-weight: 500;
        font-size: 20px;
        line-height: 20px;
        margin-bottom: 32px;
      }
    }

    .publication-group {
      width: 1140px;
      margin: 0 auto;

      &:first-child {
        margin-top: 32px;
      }

      &-header {
        width: 100%;
        height: 64px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #979797;

        img {
          margin: 0 4px;
          width: 36px;
          height: 36px;
        }

        span {
          margin-left: 8px;
          line-height: 20px;
          font-size: 22px;
          color: #333;
          font-weight: 500;
        }
        .test {
          color: #666;
          font-size: 14px;
          font-weight: 400;
        }
      }

      &-body {
        padding: 32px 0 18px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        overflow: visible;

        &-item {
          margin-bottom: 30px;
          margin-right: 30px;
          overflow: visible;

          &:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .showcases-group {
      width: 1140px;
      margin: 0 auto;
      padding: 26.5px 0 91px;
      border-top: 2px dashed #d8d8d8;

      .showcases-title {
        color: #000000;
        font-weight: 500;
        font-size: 20px;
        line-height: 20px;
        margin-bottom: 40px;
      }

      .showcase-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      .showcase-footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 20px;

        .qm-button {
          background-color: #eeeeee;
          border: 1px solid #cccccc;
          color: #000000;
        }
      }
    }
  }
}
</style>
